import { httpClient } from "../../httpClient";

type Delegate = {
  id: number;
  delegateEmail: string;
  isActive: boolean;
};

export async function delDelegate(id: Delegate["id"]): Promise<boolean> {
  try {
    const { status } = await httpClient.delete(`/api/v1/user/delegates/${id}`);

    return status === 200;
  } catch (error) {
    throw error;
  }
}

export async function getDelegates(): Promise<Delegate[]> {
  try {
    const { data } = await httpClient.get<{
      delegates: Delegate[];
    }>(`/api/v1/user/delegates`);

    return data.delegates;
  } catch (error) {
    throw error;
  }
}

export async function postDelegate(payload: {
  delegateEmail: string;
  isActive: boolean;
}): Promise<Delegate> {
  try {
    const { data } = await httpClient.post<Delegate>(
      `/api/v1/user/delegates`,
      payload
    );

    return data;
  } catch (error) {
    throw error;
  }
}

export async function putDelegate(delegate: Delegate): Promise<Delegate> {
  try {
    const { id, ...payload } = delegate;
    const { data } = await httpClient.put<Delegate>(
      `/api/v1/user/delegates/${id}`,
      payload
    );

    return data;
  } catch (error) {
    throw error;
  }
}
